export const EXERCISE_FILTERS = [
  { label: "All", match: null },
  { label: "Weight Management", match: ["Weight Management", "Weight Loss Support"] },
  { label: "Diabetes", match: ["Type 2 Diabetes"] },
  { label: "PCOS", match: ["PCOS"] },
  { label: "Heart Health", match: ["Heart Health", "High Blood Pressure", "High Cholesterol"] },
  { label: "Joint & Mobility", match: ["Joint & Mobility", "Back Mobility", "Neck & Shoulder Mobility", "Knee Care", "Joint-Friendly Fitness"] },
  { label: "Senior Fitness", match: ["Senior Fitness"] },
  { label: "Stress & Relaxation", match: ["Stress & Relaxation", "Stress Management", "Sleep & Relaxation"] },
  { label: "Strength", match: ["Strength"] },
  { label: "Flexibility", match: ["Flexibility"] },
  { label: "General Fitness", match: ["General Fitness", "General Healthy Lifestyle", "Beginner Fitness"] },
];

export const EXERCISE_CATEGORIES = [
  "Weight Management", "Diabetes", "PCOS", "Heart Health", "Joint & Mobility",
  "Senior Fitness", "Stress & Relaxation", "Strength", "Flexibility", "General Fitness",
];

export const HEALTH_TAGS = [
  "Weight Management", "Weight Loss Support", "Type 2 Diabetes", "PCOS", "Thyroid Health", "Fatty Liver",
  "High Blood Pressure", "Heart Health", "High Cholesterol", "Digestive Wellness", "IBS", "Constipation",
  "Back Mobility", "Neck & Shoulder Mobility", "Knee Care", "Joint-Friendly Fitness", "Bone Health",
  "Menopause & Midlife Fitness", "Stress Management", "Sleep & Relaxation", "Senior Fitness",
  "Beginner Fitness", "General Healthy Lifestyle",
];

export const DIFFICULTIES = ["Beginner", "Intermediate", "Advanced"];

export const DIFFICULTY_STYLES = {
  Beginner: "bg-emerald-500 text-emerald-950",
  Intermediate: "bg-amber-400 text-amber-950",
  Advanced: "bg-rose-500 text-white",
};

export const matchesFilter = (ex, filter) => {
  if (!filter.match) return true;
  if (filter.match.includes(ex.category)) return true;
  return (ex.tags || []).some((t) => filter.match.includes(t));
};
